import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ClipLoader } from 'react-spinners';
import closeIcon from './images/close-message.svg';
import './DeleteWorkOrderFile.css';

export default function DeleteWorkOrderFile({
  workOrderFileId,
  closeModal,
  refetchFiles,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleted, setIsDeleted] = useState({
    completed: false,
    success: false,
  });
  const token = localStorage.getItem('token');
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const { mutate: deleteWorkOrderMutate } = useMutation({
    mutationFn: () =>
      fetch(`${apiUrl}/work-order-files/${workOrderFileId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),

    onSuccess: (response) => {
      if (response.status === 204) {
        setIsDeleted({ completed: true, success: true });
        refetchFiles();
        setIsLoading(false);
        window.popup.hide();
        return;
      }
      setIsDeleted({ completed: true, success: false });
      setIsLoading(false);
      window.popup.hide();
    },
    onError: (error) => {
      setIsDeleted({ completed: true, success: false });
      console.log('error', error);
      setIsLoading(false);
      window.popup.hide();
    },
  });

  const handleWorkOrderDeletion = () => {
    deleteWorkOrderMutate();
    setIsLoading(true);
  };

  return (
    <>
      <div className="delete-file-modal-shadow" onClick={closeModal}></div>
      <div className="delete-file-modal">
        <div className="delete-file-modal-container">
          <div className="delete-file-modal-header">
            <div className="delete-file-modal-header-title">
              Brisanje datoteke
            </div>
            <button
              style={{ fontWeight: 'bolder' }}
              className="delete-file-modal-close-button"
              onClick={closeModal}
            >
              <img src={closeIcon} style={{ height: '10px' }} alt="Icon" />
            </button>
          </div>
          <div className="delete-file-modal-body">
            {isLoading && (
              <div className="delete-file-spinner">
                <ClipLoader
                  color={'gray'}
                  loading={isLoading}
                  size={60}
                  data-testid="loader"
                />
              </div>
            )}

            {!isLoading && (
              <div className="delete-work-order-file-container">
                {!isDeleted.completed && (
                  <div className="delete-work-order-file-body">
                    <h3 className="delete-work-order-file-confirm">
                      Da li ste sigurni da želite obrisati datoteku?
                    </h3>
                    <div className="delete-work-order-file-buttons">
                      <button
                        className="delete-work-order-file-return-button"
                        onClick={closeModal}
                      >
                        Nazad
                      </button>
                      <button
                        className="delete-work-order-file-confirm-button"
                        onClick={handleWorkOrderDeletion}
                      >
                        Obriši
                      </button>
                    </div>
                  </div>
                )}

                {isDeleted.completed && (
                  <div>
                    <h3 className="delete-work-order-file-confirm">
                      {isDeleted.success
                        ? 'Datoteka je uspješno obrisana.'
                        : 'Trenutno nije moguće obrisati datoteku.'}
                    </h3>
                    <button
                      type="submit"
                      className="delete-work-order-file-modal-close-button"
                      onClick={closeModal}
                    >
                      Zatvori
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
